import { useMutation } from "convex/react";
import type { FunctionArgs } from "convex/server";
import { useCallback } from "react";
import { useNavigate } from "react-router";

import { getUniqueName } from "@/helpers/getUniqueName";
import { useAllDecks } from "@/hooks/useAllDecks";
import { api } from "@convex/_generated/api";

type AddDeckProps = Partial<FunctionArgs<typeof api.decks.add>>;

export function useAddDeck(): (deckProps?: AddDeckProps) => Promise<void> {
  const navigate = useNavigate();
  const decks = useAllDecks();
  const addDeckMutation = useMutation(api.decks.add);

  return useCallback(
    async (deckProps?: AddDeckProps) => {
      const name =
        deckProps?.name !== "" && deckProps?.name !== undefined
          ? deckProps.name
          : getUniqueName(
              "New Deck",
              decks?.map((deck) => deck.name)
            );
      const deckId = await addDeckMutation({ ...deckProps, name });
      void navigate(`/decks/${deckId}`);
    },
    [addDeckMutation, decks, navigate]
  );
}
